import isDataUri from 'is-data-uri';
import * as comUtils from 'utils/Common';


/**
 * Convert an <img> source `url` to a data URI and `callback(err, uri)`.
 *
 * @param {String} url
 * @param {Function} callback
 */

export function imageToDataUri(url, callback) {
  const canvas = window.document.createElement('canvas')
  const img = window.document.createElement('img')

  if (!canvas.getContext) {
    return setTimeout(callback, 0, new Error('Canvas is not supported.'))
  }

  img.onload = () => {
    const ctx = canvas.getContext('2d')
    canvas.width = img.width
    canvas.height = img.height
    ctx.drawImage(img, 0, 0)
    const dataUri = canvas.toDataURL('image/png')
    callback(null, dataUri)
  }

  img.ononerror = () => {
    callback(new Error('Failed to load image.'))
  }

  img.setAttribute('crossOrigin', 'anonymous')
  img.src = url
}


// See https://stackoverflow.com/a/12300351/1446284
export function dataUriToBlob(dataURI) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  var byteString = atob(dataURI.split(',')[1]);

  // separate out the mime component
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

  // write the bytes of the string to an ArrayBuffer
  var ab = new ArrayBuffer(byteString.length);

  // create a view into the buffer
  var ia = new Uint8Array(ab);

  // set the bytes of the buffer to the correct values
  for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
  }

  // write the ArrayBuffer to a blob, and you're done
  var blob = new Blob([ab], {type: mimeString});
  return blob;

}


export function loadImageFile(url, callback) {
  if (isDataUri(url)) {
    const file = dataUriToBlob(url)
    setTimeout(() => {
      callback(null, file)
    })
  } else {
    imageToDataUri(url, (err, uri) => {
      const file = dataUriToBlob(uri)
      callback(err, file)
    })
  }
}

// This can be handy if you need to download image from external domains
// Note: This may not always work due to CORS
// See
// https://stackoverflow.com/a/17527821/1446284
// https://blog.logrocket.com/programmatic-file-downloads-in-the-browser-9a5186298d5c/
export function downloadImageFile(url) {
  loadImageFile(url, (err, blob) => {
    if (err) return;
    const filename = comUtils.extractFilenameFromUrl(url);
    const urlObject = URL.createObjectURL(blob);

    var tag = document.createElement('a');
    tag.href = urlObject;
    tag.download = filename;
    document.body.appendChild(tag);
    tag.click();
    document.body.removeChild(tag);
  })
}

export function checkValidImage(src, onSuccess, onError) {
  const img = new Image();
  img.onload = () => onSuccess(img);
  img.onerror = () => onError(img);
  img.src = src;
}

